export enum Page {
  HOME,
  BLOG,
}
